export default "__VITE_ASSET__f60b3707__"